import NavTitle from './nav-title';

export default NavTitle;
